<!-- Page Banner -->
<div class="page-banner-area ptb-100 four" style="background-image: url(../../../../assets/images/information.jpg);">
  <div class="container">
    <div class="page-banner-content">
      <h2 *ngIf="order=='normativa'">Normativa y políticas</h2>
      <h2 *ngIf="order=='derechos'">Declaración de Principios de Inversión</h2>
      <h2 *ngIf="order=='auditoria'">Cuentas anuales e Informes</h2>
      <h2 *ngIf="order=='junta'">Junta de Gobierno</h2>
      <h2 *ngIf="order=='asamblea'">Asamblea general</h2>
    </div>
  </div>
</div>


<div class="service-details-area pt-100 pb-100">
  <div class="container">
    <div class="row">
      @if(order=='normativa'){
      <div class="col-lg-12 col-md-12">
        <aside class="widget-area">
          <div class="widget widget_download_file">
            <h1 class="widget-title">Documentación</h1>
            <p>Todos los documentos disponibles son los que actualmente están en vigor.</p>
            <div>
              <h6>Estatutos y reglamentos de Prestaciones</h6>
              <ul class="download-file-list">
                <li>
                  <a href="../../../../assets/files/Estatutos y Reglamento Montepío.pdf" target="_blank">
                    <img src="../../../../assets/images/pdf.png" alt="image">
                    <div class="title">
                      <h4>Estatutos y Reglamento Montepío</h4>
                      <span>PDF | 326 KB</span>
                    </div>
                  </a>
                </li>
              </ul>
              <h6>Políticas de buen gobierno</h6>
              <ul class="download-file-list">
                <li>
                  <a href="../../../../assets/files/WEB- PFA2026V1 Política de la Función Actuarial VF.pdf" target="_blank">
                    <img src="../../../../assets/images/pdf.png" alt="image">
                    <div class="title">
                      <h4>Política de la Función Actuarial</h4>
                      <span>PDF | 467 KB</span>
                    </div>
                  </a>
                </li>
                <li>
                  <a href="../../../../assets/files/WEB- PEX2026V1 Política de Externalización VF.pdf" target="_blank">
                    <img src="../../../../assets/images/pdf.png" alt="image">
                    <div class="title">
                      <h4>Política de Externalización</h4>
                      <span>PDF | 472 KB</span>
                    </div>
                  </a>
                </li>
                <li>
                  <a href="../../../../assets/files/WEB- PAI2026V1 Política Función Auditoría Interna VF.pdf" target="_blank">
                    <img src="../../../../assets/images/pdf.png" alt="image">
                    <div class="title">
                      <h4>Política de Función de Auditoría Interna</h4>
                      <span>PDF | 446 KB</span>
                    </div>
                  </a>
                </li>
                <li>
                  <a href="../../../../assets/files/WEB- PGR2026V1 Política Sistema de Gestión de Riesgos y Función de Gestión de Riesgos 2026 VF.pdf" target="_blank">
                    <img src="../../../../assets/images/pdf.png" alt="image">
                    <div class="title">
                      <h4>Política Sistema de Gestión de Riesgos y Función de Gestión de Riesgos 2026</h4>
                      <span>PDF | 926 KB</span>
                    </div>
                  </a>
                </li>
                <li>
                  <a href="../../../../assets/files/WEB- PCI2026V1 Política Control Interno_Montepio 2026 + Anexo Operaciones vinculadas VF.pdf" target="_blank">
                    <img src="../../../../assets/images/pdf.png" alt="image">
                    <div class="title">
                      <h4>Política Control Interno + Anexo Operaciones vinculadas</h4>
                      <span>PDF | 597 KB</span>
                    </div>
                  </a>
                </li>
              </ul>

              <h6>Política de protección de datos</h6>
              <ul class="download-file-list">
                <li>
                  <a href="../../../../assets/files/PPD2026V1 POLÍTICA DE GOBERNANZA PD MONTEPÍO  VF.pdf" target="_blank">
                    <img src="../../../../assets/images/pdf.png" alt="image">
                    <div class="title">
                      <h4>Política de Gobernanza en Materia de Protección de Datos</h4>
                      <span>PDF | 1.4 MB</span>
                    </div>
                  </a>
                  <p>De acuerdo con el Reglamento (UE) 2016/679, General de Protección de Datos, y la Ley Orgánica
                    3/2018, los socios y partícipes del Montepío del Igualatorio EPSV pueden ejercer sus derechos de
                    acceso, rectificación, supresión, limitación, portabilidad y oposición (derechos ARSULIPO) mediante
                    solicitud dirigida a la entidad, acompañando documento identificativo.
                    Para más información sobre cómo ejercer estos derechos, y los formularios necesarios, puede
                    consultar la página oficial de la Agencia Española de Protección de Datos (AEPD):
                    <a
                      href="https://www.aepd.es/es/derechos-y-deberes/conoce-tus-derechos">https://www.aepd.es/es/derechos-y-deberes/conoce-tus-derechos</a>
                    En caso de no obtener satisfacción en el ejercicio de sus derechos, podrá presentar una reclamación
                    ante la AEPD a través de su sede electrónica:
                    <a
                      href="https://sedeagpd.gob.es/sede-electronica-web/">https://sedeagpd.gob.es/sede-electronica-web/</a>
                  </p>
                </li>
              </ul>
            </div>

          </div>
        </aside>
      </div>
      }

      @if(order=='auditoria'){
      <div class="col-lg-12 col-md-12">
        <aside class="widget-area">
          <div class="widget widget_download_file">
            <h1 class="widget-title">Documentación</h1>
            <div>
              <ul class="download-file-list">
                <li>
                  <a href="../../../../assets/files/Informe Actuarial.pdf" target="_blank">
                    <img src="../../../../assets/images/pdf.png" alt="image">
                    <div class="title">
                      <h4>Informe Actuarial 2024</h4>
                      <span>PDF | 215 KB</span>
                    </div>
                  </a>
                </li>
                <li>
                  <a href="../../../../assets/files/Informe Actuarial del 2025.pdf" target="_blank">
                    <img src="../../../../assets/images/pdf.png" alt="image">
                    <div class="title">
                      <h4>Informe Actuarial 2025</h4>
                      <span>PDF | 314 KB</span>
                    </div>
                  </a>
                </li>
              </ul>
              <h6>Informes Auditores</h6>
              <ul class="download-file-list">
                <li>
                  <a href="../../../../assets/files/Informe Auditoría de Cuentas 2021.pdf" target="_blank">
                    <img src="../../../../assets/images/pdf.png" alt="image">
                    <div class="title">
                      <h4>Informe Auditoría de Cuentas 2021</h4>
                      <span>PDF | 12 MB</span>
                    </div>
                  </a>
                </li>
                <li>
                  <a href="../../../../assets/files/Informe Auditoría de Cuentas 2022.pdf" target="_blank">
                    <img src="../../../../assets/images/pdf.png" alt="image">
                    <div class="title">
                      <h4>Informe Auditoría de Cuentas 2022</h4>
                      <span>PDF | 13.9 MB</span>
                    </div>
                  </a>
                </li>
                <li>
                  <a href="../../../../assets/files/CCAA + Auditoria  Montepío 2023 firmadas.pdf" target="_blank">
                    <img src="../../../../assets/images/pdf.png" alt="image">
                    <div class="title">
                      <h4>Informe Auditoría de Cuentas 2023</h4>
                      <span>PDF | 18.6 MB</span>
                    </div>
                  </a>
                </li>
                <li>
                  <a href="../../../../assets/files/Cuenta Anuales + Informe de Gestion 2024.pdf" target="_blank">
                    <img src="../../../../assets/images/pdf.png" alt="image">
                    <div class="title">
                      <h4>Cuentas anuales + Informe de gestion del 2024</h4>
                      <span>PDF | 12.3 MB</span>
                    </div>
                  </a>
                </li>
                <li>
                  <a href="../../../../assets/files/CCAA + I GESTION + I. AUDITORIA MONTEPIO 2025.pdf" target="_blank">
                    <img src="../../../../assets/images/pdf.png" alt="image">
                    <div class="title">
                      <h4>Cuentas anuales + Informe de gestion del 2025</h4>
                      <span>PDF | 67.1 MB</span>
                    </div>
                  </a>
                </li>
              </ul>
            </div>

          </div>
        </aside>
      </div>
      }

      @if(order=='asamblea'){
      <div class="col-lg-12 col-md-12">
        <div class="img-asamblea row">
          <div class="col-lg-12">
            <h4>Asamblea General Ordinaria
              del Montepío del Igualatorio Entidad de
              Previsión Social Voluntaria de Empleo, EPSV</h4>
            <h6>23 DE ABRIL DE 2026</h6>
          </div>

        </div>

      </div>
      <div class="col-lg-12 col-md-12">
        <aside class="widget-area">
          <div class="widget widget_download_file">
            <h1 class="widget-title">Documentación</h1>
            <div>
              <h6>Asamblea general 2026</h6>
              <ul class="download-file-list">
                <li>
                  <a href="../../../../assets/files/Acta Asamblea General 23.04.2026 con presentación.pdf"
                    target="_blank">
                    <img src="../../../../assets/images/pdf.png" alt="image">
                    <div class="title">
                      <h4>Acta Asamblea General 23.04.2026</h4>
                      <span>PDF | 4.27 MB</span>
                    </div>
                  </a>
                </li>
                <li>
                  <a href="../../../../assets/files/Convocatoria Asamblea General 2026.pdf" target="_blank">
                    <img src="../../../../assets/images/pdf.png" alt="image">
                    <div class="title">
                      <h4>Convocatoria asamblea general ordinaria 2026</h4>
                      <span>PDF | 211 KB</span>
                    </div>
                  </a>
                </li>
                <li>
                  <a href="../../../../assets/files/Propuestas de acuerdos 2026.pdf" target="_blank">
                    <img src="../../../../assets/images/pdf.png" alt="image">
                    <div class="title">
                      <h4>Propuesta de acuerdos</h4>
                      <span>PDF | 76 KB</span>
                    </div>
                  </a>
                </li>
                <li>
                  <a href="../../../../assets/files/Delegación de voto Interactiva 2026.pdf" target="_blank">
                    <img src="../../../../assets/images/pdf.png" alt="image">
                    <div class="title">
                      <h4>Delegación del voto</h4>
                      <span>PDF | 105 KB</span>
                    </div>
                  </a>
                </li>
                <li>
                  <a href="../../../../assets/files/CCAA + I GESTION + I. AUDITORIA MONTEPIO 2025.pdf" target="_blank">
                    <img src="../../../../assets/images/pdf.png" alt="image">
                    <div class="title">
                      <h4>Cuentas anuales + Informe de gestion del 2025</h4>
                      <span>PDF | 67.1 MB</span>
                    </div>
                  </a>
                </li>
              </ul>
            </div>
            <div>
              <h6>Asamblea general 2025</h6>
              <ul class="download-file-list">
                <li>
                  <a href="../../../../assets/files/Convocatoria asamblea 29-04.pdf" target="_blank">
                    <img src="../../../../assets/images/pdf.png" alt="image">
                    <div class="title">
                      <h4>Convocatoria asamblea general ordinaria 2025</h4>
                      <span>PDF | 87 KB</span>
                    </div>
                  </a>
                </li>
                <li>
                  <a href="../../../../assets/files/Propuesta de acuerdos-2025-04-29.pdf" target="_blank">
                    <img src="../../../../assets/images/pdf.png" alt="image">
                    <div class="title">
                      <h4>Propuesta de acuerdos</h4>
                      <span>PDF | 92 KB</span>
                    </div>
                  </a>
                </li>
                <li>
                  <a href="../../../../assets/files/Delegación Voto Asamblea 2025-04-29 interactivo.pdf"
                    target="_blank">
                    <img src="../../../../assets/images/pdf.png" alt="image">
                    <div class="title">
                      <h4>Delegación del voto</h4>
                      <span>PDF | 144 KB</span>
                    </div>
                  </a>
                </li>
                <li>
                  <a href="../../../../assets/files/Cuenta Anuales + Informe de Gestion 2024.pdf" target="_blank">
                    <img src="../../../../assets/images/pdf.png" alt="image">
                    <div class="title">
                      <h4>Cuentas anuales + Informe de gestion del 2024</h4>
                      <span>PDF | 12.3 MB</span>
                    </div>
                  </a>
                </li>

              </ul>
            </div>

          </div>
        </aside>
      </div>
      }

      @if(order=='derechos'){
      <div class="col-lg-12 col-md-12">
        <aside class="widget-area">
          <div class="widget widget_download_file">
            <h1 class="widget-title">Documentación</h1>
            <div>
              <h6>Principios de inversiones</h6>
              <ul class="download-file-list">
                <li>
                  <a href="../../../../assets/files/DPI2026V1 Declaración de Principios de Inversión 2026.pdf"
                    target="_blank">
                    <img src="../../../../assets/images/pdf.png" alt="image">
                    <div class="title">
                      <h4>Declaración de Principios de Inversión</h4>
                      <span>PDF | 836 KB</span>
                    </div>
                  </a>
                </li>
              </ul>
            </div>

          </div>
        </aside>
      </div>
      }

      @if(order=='junta'){
      <div class="col-lg-12 col-md-12">
        <div class="info-desc">
          <h1>Composición de la Junta de Gobiero del Montepío del Igualatorio</h1>
          <div class="content">
            <table class="table table-striped">
              <thead>
                <tr>
                  <th scope="col">Cargo</th>
                  <th scope="col">Nombre</th>
                  <th scope="col">Fecha de incio</th>
                  <th scope="col">Fecha fin</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td>Presidente/a</td>
                  <td>MAGDALENA MUGICA PORTILLO</td>
                  <td>20.06.2023</td>
                  <td>20.06.2027</td>
                </tr>
                <tr>
                  <td>Vicepresidente</td>
                  <td>IÑIGO VILAR ACHABAL</td>
                  <td>29.04.2025</td>
                  <td>29.04.2029</td>
                </tr>
                <tr>
                  <td>Vocal</td>
                  <td>JOSE MARIA CASTAÑOS DEL MOLINO</td>
                  <td>29.04.2025</td>
                  <td>29.04.2029</td>
                </tr>
                <tr>
                  <td>Vocal</td>
                  <td>AINHOA RUBIO EREÑO</td>
                  <td>20.06.2023</td>
                  <td>20.06.2027</td>
                </tr>
                <tr>
                  <td>Vocal</td>
                  <td>AITOR BARAÑANO ABASOLO</td>
                  <td>23.04.2026</td>
                  <td>23.04.2030</td>
                </tr>
                <tr>
                  <td>Vocal</td>
                  <td>JESUS GORROCHATEGUI EREÑO</td>
                  <td>23.04.2026</td>
                  <td>23.04.2030</td>
                </tr>
                <tr>
                  <td>Vocal</td>
                  <td>MARIO PUGA BARREDO</td>
                  <td>23.04.2026</td>
                  <td>23.04.2030</td>
                </tr>
                <tr>
                  <td>Vocal</td>
                  <td>MIGUEL ZALDUA ARRESE</td>
                  <td>23.04.2026</td>
                  <td>23.04.2030</td>
                </tr>
                <tr>
                  <td>Vocal</td>
                  <td>MYRIAM BOYERO URANGA</td>
                  <td>23.04.2026</td>
                  <td>23.04.2030</td>
                </tr>
                <tr>
                  <td>Secretario/a no miembro</td>
                  <td>JOSE ORIOL PROSPER CARDOSO</td>
                  <td>11.01.2023</td>
                  <td></td>
                </tr>
              </tbody>
            </table>
            <p class="msn">En ausencia de una renovación formal de los cargos de la Junta de Gobierno al vencimiento de
              su mandato, los miembros que ocupan dichos cargos continuarán ejerciendo sus funciones en régimen de
              prórroga tácita hasta que se celebre la próxima Asamblea General.</p>
          </div>
        </div>
      </div>
      }
    </div>
  </div>
</div>